module.exports = __webpack_public_path__ + "img/info1.9a48fbeb.png";